// extracted by mini-css-extract-plugin
module.exports = {"form":"footer_form__3ac6h","copyright":"footer_copyright__34ZuF","blocks":"footer_blocks__2bcSi","element":"footer_element__1XTkj","content":"footer_content__1LQLH"};